<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="fieldDefinitionListHeaders"
    :request-func="fieldDefinitionList">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Додати поле
      </v-btn>
    </template>
    <template #item.name="{ item }">
      <span class="font-weight-bold">{{ item.name }}</span>
    </template>
    <template #item.fieldType="{ item }">
      <v-chip :color="getFieldTypeColor(item.fieldType)" size="small">{{
        $directory
          .get('fieldTypes', null, { type: 'collection' })
          .getItem(item.fieldType)?.name || item.fieldType
      }}</v-chip>
    </template>
    <template #item.usages>
      <v-chip size="small" color="blue">
        <span class="font-weight-bold">0</span>
      </v-chip>
    </template>
    <template #item.actions="{ item }">
      <v-btn
        variant="flat"
        border
        color="white"
        density="comfortable"
        class="mr-2"
        @click="openUpdateDialog(item)">
        <span class="font-weight-regular">Редагувати</span>
      </v-btn>
      <v-btn
        variant="flat"
        border
        color="white"
        density="comfortable"
        @click="toggleActive(item)">
        <span class="font-weight-regular text-error">Видалити</span>
      </v-btn>
    </template>
  </b-server-table>
</template>

<script lang="ts">
import { ref } from 'vue'
import { openDialog } from '@/dialog'
import { BServerTable } from 'best-modules/components'
import {
  fieldDefinitionActivate,
  fieldDefinitionDeactivate,
  fieldDefinitionList,
} from '@/requests/fieldDefinition'
import { fieldDefinitionListHeaders } from '@/utils/tableHeaders'
import { fillDirectory } from '@/directory'
import { getFieldTypeColor } from './helpers'

export default {
  name: 'FieldDefinitionList',
  components: { BServerTable },
  data() {
    return {
      fieldDefinitionListHeaders,
    }
  },
  methods: { fieldDefinitionList, getFieldTypeColor },
  setup() {
    fillDirectory('fieldTypes')
    const tableRenderKey = ref(1)

    const openCreateDialog = () => {
      openDialog({
        name: 'FieldDefinition',
        action: 'create',
        params: {
          title: 'Створити поле',
          submitLabel: 'Створити',
          cb: () => (tableRenderKey.value += 1),
        },
      })
    }

    const openUpdateDialog = (item: any) => {
      openDialog({
        name: 'FieldDefinition',
        action: 'update',
        params: {
          title: 'Редагувати поле',
          submitLabel: 'Зберегти',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { itemData: item },
      })
    }

    const toggleActive = (item: any) => {
      const url = item.isActive
        ? fieldDefinitionDeactivate
        : fieldDefinitionActivate
      return url(item.id).then(() => {
        tableRenderKey.value += 1
      })
    }

    return {
      toggleActive,
      openCreateDialog,
      tableRenderKey,
      openUpdateDialog,
    }
  },
}
</script>
